export function isStringArray(value: any): value is string[] {
  return Array.isArray(value) && value.every((item) => typeof item === 'string');
}

export function arraysEqual<T>(a: T[] | undefined, b: T[] | undefined): boolean {
  const arr1 = a || [];
  const arr2 = b || [];
  return arr1.length === arr2.length && arr1.every((val, i) => val === arr2[i]);
}

export function isObjectEmpty(obj: object): boolean {
  return !obj || Object.keys(obj).length === 0;
}

export function getFileFromInputEvent(event: Event | null | undefined): File | null {
  return (event?.target as HTMLInputElement | null)?.files?.[0] ?? null;
}

export function isAllowedFileType(
  file: File | null | undefined,
  allowedMimeTypes: readonly string[],
): boolean {
  return !!file && allowedMimeTypes.includes(file.type);
}

export function deepEqual(a: unknown, b: unknown): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}

export const getQueryStringFromParams = function <T extends object>(params: T): string {
  return new URLSearchParams(
    Object.entries(params)
      .filter(([, value]) => value !== undefined && value !== null)
      .reduce(
        (acc, [key, value]) => ({ ...acc, [key]: String(value) }),
        {} as Record<string, string>,
      ),
  ).toString();
};

export const getArrayFromNumber = function (value: number): number[] {
  return [...Array(value).keys()];
};
